import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

import { styled } from '@portal/common/theme';

import { FAVORITE_CONTENT_PATH } from '../../../router/paths';
import MyListsMenu from './MyListsMenu';
import PublicListsMenu from './PublicListsMenu';

const SidenavSubmenu = styled('div')(({ theme }) => ({
    color: theme.color.white,
    background: theme.color.gray95,
    display: 'flex',
    flexFlow: 'column nowrap',
    padding: '60px 20px 0 20px',
    overflowY: 'hidden',
    ':hover': {
        overflowY: 'scroll',
    },

    minWidth: 160,
    width: 160,
    [theme.breakpoint.md]: {
        padding: '90px 30px 0 30px',
        minWidth: 230,
        width: 230,
    },
}));

const ListsRoute: FC = () => (
    <Routes>
        <Route
            path={`${FAVORITE_CONTENT_PATH}/*`}
            element={
                <SidenavSubmenu>
                    <MyListsMenu />
                    <PublicListsMenu />
                </SidenavSubmenu>
            }
        />
    </Routes>
);

export default ListsRoute;
